<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <el-row>
        <el-col :span="7" class="content-left">
          <div class="trade-container">
            <el-card class="trade-nav-panel">
              <div slot="header" class="clearfix">
                <span class="panel-header">分配配额</span>
              </div>
              <el-menu
                :default-active="`${defineList[0].brandCode}${defineList[0].programTypeName}${defineList[0].channelList[0].ispChannelName}`"
                v-if="defineList.length"
              >
                <div v-for="(item, index) in defineList" :key="index">
                  <el-menu-item
                    :index="`${item.brandCode}${item.programTypeName}${subItem.ispChannelName}`"
                    v-for="(subItem, subIndex) in item.channelList"
                    :key="subIndex"
                    @click="showDefineInfo(item, subIndex)"
                  >
                    <span slot="title">{{ item.brandName }}-{{ item.programTypeName }}-{{ subItem.ispChannelName }}</span>
                  </el-menu-item>
                </div>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="17" class="content-right">
          <div class="title">额度信息</div>
          <div class="content">
            <el-row>
              <el-col :span="4">品牌</el-col>
              <el-col :span="8">{{ defineInfo.brandName }}</el-col>
              <el-col :span="4">项目</el-col>
              <el-col :span="8">{{ defineInfo.programTypeName }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="4">渠道</el-col>
              <el-col :span="8">{{ defineInfo.ispChannelName }}</el-col>
              <el-col :span="4">总额度</el-col>
              <el-col :span="8">{{ defineInfo.investMax | thousandSymbol }}</el-col>
            </el-row>
          </div>
          <div class="title">分配规则</div>
          <div class="content">
            <el-tree :data="buList" ref="tree" node-key="regionCode" :props="{ label: 'orgName', children: 'subOrgList' }">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.orgType !== '04' || data.quotaType === '02'"
                  >{{ data.orgType === '02' ? 'BU -' : 'Region -' }} {{ node.label }}{{ data.orgType !== '04' ? `（${data.quotaTotal}）` : '' }}</span
                >
                <template v-if="data.quotaType === '02'">
                  <el-input-number v-model="data.quotaTotal" :min="0" v-if="data.orgType === '04'" @blur="getAccount(data.orgCode)"></el-input-number>
                  <el-button type="danger" size="mini" @click="shiftM3(data.orgCode)" v-if="data.orgType === '04' && data.canShiftMode">按M3分配</el-button>
                </template>
                <div v-if="data.quotaType === '01'" style="display: flex; flex-wrap: wrap; align-items: center">
                  <div v-for="(item, index) in data.m3List" :key="index">
                    M3-{{ item.clientName }}
                    <el-input-number v-model="item.quotaTotal" :min="0" v-if="data.orgType === '04'" @blur="getAccount(data.orgCode)"></el-input-number>
                  </div>
                  <el-button type="danger" size="mini" @click="shiftM3(data.orgCode)" v-if="data.orgType === '04'">按Region分配</el-button>
                </div>
              </span>
            </el-tree>
          </div>
        </el-col>
      </el-row>
      <div class="handle-box fixed">
        <el-button class="btn-red-plain" @click="goBack">返回</el-button>
        <el-button type="danger" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/content-header"
import ispApi from '@/api/isp'
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      buList: [],
      queryParams: {
        brandCode: '',
        ispChannelCode: '',
        programType: ''
      },
      defineList: [],
      defineInfo: {},
      authMap: {
        '28063811': '01AAAB',
        '28062577': '01AHME',
        '28077456': '01AAHP',
        '28051023': 'all',
        '28070610': 'all'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getDefaultDefine()
    },
    // 左侧列表
    getDefaultDefine () {
      ispApi.getDefaultDefine().then(res => {
        if (res.data.resultCode === '0') {
          this.defineList = []
          res.data.resultData.ispDefaultDefineList.sort((a, b) => { return b.programType - a.programType }).forEach(item => {
            item.btmpBrandDTOList.forEach(brand => {
              if (brand.brandCode === this.authMap[this.userInfo.employeeCode] || this.authMap[this.userInfo.employeeCode] === 'all') {
                let obj = {}
                obj.brandCode = brand.brandCode
                obj.brandName = brand.brandName
                obj.programType = item.programType
                obj.programTypeName = item.programTypeName
                obj.channelList = item.ispDefaultChannelMap[obj.brandCode]
                // obj.channelList.forEach(channel => {
                //   for (const i in item.investCapitalMaxMap) {
                //     if (i.indexOf(obj.brandCode) !== -1 && i.indexOf(channel.ispChannelCode) !== -1) {
                //       channel.investMax = item.investCapitalMaxMap[i]
                //     }
                //   }
                // })
                this.defineList.push(obj)
              }

            })
          })
          this.defineList = this.defineList.sort((a, b) => {
            const codeA = a.brandCode.toUpperCase()
            const codeB = b.brandCode.toUpperCase()
            if (codeA > codeB) {
              return -1
            }
          })
          this.showDefineInfo(this.defineList[0])
        }
      })
    },
    // 切换列表项目
    showDefineInfo (info, subIndex) {
      if (!subIndex) {
        subIndex = 0
      }
      this.defineInfo = info
      this.defineInfo.ispChannelName = info.channelList[subIndex].ispChannelName
      this.defineInfo.ispChannelCode = info.channelList[subIndex].ispChannelCode
      // this.defineInfo.investMax = info.channelList[subIndex].investMax

      this.queryParams.brandCode = info.brandCode
      this.queryParams.ispChannelCode = info.channelList[subIndex].ispChannelCode
      this.queryParams.programType = info.programType
      this.getQuotaOrg()
    },
    // 获取区域列表
    getQuotaOrg () {
      this.loading = true
      ispApi.getQuotaOrg(this.queryParams).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.buList = res.data.resultData.baseOrgDTOList
          this.initData()
        }
      }).catch(() => { this.loading = false })
    },
    // 初始化区域列表
    initData () {
      this.$set(this.defineInfo, 'investMax', 0)
      this.buList = this.buList.map(item => {
        if (!item.ispTradeQuotaDTO || !item.ispTradeQuotaDTO.quotaTotal) {
          this.$set(item, 'quotaTotal', 0)
        } else {
          this.$set(item, 'quotaTotal', item.ispTradeQuotaDTO.quotaTotal)
          this.defineInfo.investMax += item.ispTradeQuotaDTO.quotaTotal
        }

        item.subOrgList.map(regionItem => {
          regionItem.m3List = regionItem.m3List.map(m3 => {
            if (!m3.ispTradeQuotaDTO || !m3.ispTradeQuotaDTO.quotaTotal) {
              m3.quotaTotal = 0
            } else {
              m3.quotaTotal = m3.ispTradeQuotaDTO.quotaTotal
            }
            return m3
          })
          let obj = {
            orgName: regionItem.orgName,
            orgCode: regionItem.orgCode,
            orgType: '04',
            m3List: regionItem.m3List
          }
          if (!regionItem.ispTradeQuotaDTO || !regionItem.ispTradeQuotaDTO.quotaTotal) {
            obj.canShiftMode = true
            this.$set(regionItem, 'quotaTotal', 0)
            this.$set(obj, 'quotaTotal', 0)
          } else {
            this.$set(regionItem, 'quotaTotal', regionItem.ispTradeQuotaDTO.quotaTotal)
            this.$set(obj, 'quotaTotal', regionItem.ispTradeQuotaDTO.quotaTotal)
          }
          if (regionItem.m3List[0].ispTradeQuotaDTO) {
            obj.canShiftMode = true
            obj.quotaType = '01'
          } else {
            obj.quotaType = '02'
          }
          regionItem.subOrgList = [obj]
          return regionItem
        })
        return item
      })
    },
    // 切换分配模式
    shiftM3 (orgCode) {
      this.buList.forEach(item => {
        item.subOrgList.forEach(regionItem => {
          if (regionItem.orgCode === orgCode) {
            if (regionItem.subOrgList[0].quotaType === '01') {
              regionItem.subOrgList[0].quotaType = '02'
            } else {
              regionItem.subOrgList[0].quotaType = '01'
            }
          }
        })
      })
    },
    getAccount (orgCode) {
      let index = this.buList.findIndex(item => {
        return item.subOrgList.findIndex(regionItem => {
          return regionItem.orgCode === orgCode
        }) !== -1
      })
      this.buList[index].quotaTotal = 0
      this.buList[index].subOrgList.forEach(item => {
        item.quotaTotal = 0
        item.subOrgList.forEach(regionItem => {
          if (regionItem.quotaType === '01') {
            regionItem.quotaTotal = 0
            regionItem.m3List.forEach(sItem => {
              regionItem.quotaTotal += sItem.quotaTotal || 0
            })
          } else {
            regionItem.quotaTotal = regionItem.quotaTotal
          }
          item.quotaTotal += regionItem.quotaTotal || 0
        })
        this.buList[index].quotaTotal += item.subOrgList[0].quotaTotal || 0
      })

      this.defineInfo.investMax = 0
      this.buList.forEach(item => {
        this.defineInfo.investMax += item.quotaTotal || 0
      })

    },
    goBack () {
      this.$router.go(-1)
    },
    submit () {
      this.$confirm('是否确认提交？', '提示', {
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-red-plain'
      }).then(() => {
        let canSubmit = false
        let list = this.buList.map(item => {
          let buItem = {
            quotaId: item?.ispTradeQuotaDTO?.quotaId,
            buCode: item.orgCode,
            quotaTotal: item.quotaTotal
          }
          buItem.regionVOList = item.subOrgList.map(sItem => {
            let regionItem = {
              quotaId: sItem?.ispTradeQuotaDTO?.quotaId,
              regionCode: sItem.orgCode,
              quotaTotal: sItem.quotaTotal
            }
            regionItem.quotaType = sItem.subOrgList[0].quotaType

            if (sItem.ispTradeQuotaDTO && sItem.quotaTotal < sItem.ispTradeQuotaDTO.quotaBlocked + sItem.ispTradeQuotaDTO.quotaUsed) {
              this.$message.warning(`${item.orgName} ${sItem.orgName} 分配配额低于“冻结+已用”数量，请重新填写`)
              canSubmit = true
            }
            if (regionItem.quotaType === '01') {
              regionItem.m3VOList = sItem.subOrgList[0].m3List.map(m3 => {
                let m3Item = {
                  quotaId: m3?.ispTradeQuotaDTO?.quotaId,
                  m3Code: m3.employeeCode,
                  quotaTotal: m3.quotaTotal || 0
                }
                return m3Item
              })
            }
            return regionItem
          })
          return buItem
        })
        if (canSubmit) {
          return
        }
        let params = Object.assign({}, this.queryParams)
        params.optType = '02'
        params.buVOList = list
        this.loading = true
        ispApi.handleQuotaConfig(params).then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$message.success('提交额度信息成功')
            this.$router.push({
              path: '/isp/quota-info'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {

      })
    }

  }

}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url('../../assets/images/banner-menu.jpg') center no-repeat;
  background-size: cover;
}
.trade-nav-panel {
  width: 80%;
  //   min-height: 290px;
  margin: 0 auto;
  background: $base-white;
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;

  .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left {
    padding-right: $content-middle;
  }
}
.content-right {
  padding-left: 20px;
  min-height: calc(100vh - 320px) !important;
}

.title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}
.content {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px 40px;
  //   margin: 20px 0;
  margin-bottom: 20px;
  & > .el-row {
    .el-col {
      line-height: 60px;
      &:nth-child(odd) {
        font-weight: 700;
      }
    }
  }
  .el-input-number {
    width: 80px;
    margin: 0 20px 0 10px;
  }
  ::v-deep .el-input__inner {
    height: 25px;
    padding: 0 10px;
  }
  &::v-deep .el-input-number__decrease,
  &::v-deep .el-input-number__increase {
    display: none;
  }
  ::v-deep .el-tree-node__content {
    height: auto;
    min-height: 40px;
  }
  .el-button {
    height: 25px;
    padding: 0 10px;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
  }
}
.handle-box {
  text-align: center;
  .el-button {
    margin-right: 80px;
  }
}
.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: #f3f5f9;
  z-index: 10;
}
</style>